import { FC } from "react";

/**
 * Right Arrow Icon Props Interface
 * @interface PrevPageIconProps
 */
interface PrevPageIconProps {
  color?: string
}

const PrevPageIcon: FC<PrevPageIconProps> = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.20509 3.96967C7.49799 4.26256 7.49799 4.73743 7.2051 5.03033L3.98545 8.25H15.6748C16.089 8.25 16.4248 8.58579 16.4248 9C16.4248 9.41421 16.089 9.75 15.6748 9.75H3.98545L7.2051 12.9697C7.49799 13.2626 7.49799 13.7374 7.20509 14.0303C6.9122 14.3232 6.43732 14.3232 6.14443 14.0303L1.64447 9.53033C1.35158 9.23743 1.35158 8.76257 1.64447 8.46967L6.14443 3.96967C6.43732 3.67678 6.9122 3.67678 7.20509 3.96967Z"
        fill="black"
      />
    </svg>
  );
};

export default PrevPageIcon;
